import { type PayoutCascadeAttempt } from '~/entities/payout';
import { setMode } from '~/shared/store/mode';
import { type CascadeGroup, type CascadeTrader } from '../types';

export const getTraderLabel = (trader: CascadeTrader) => {
    return trader.traderName?.value ?? trader.traderId ?? 'Неизвестный трейдер';
};

export const getEntityLabel = (name: string | undefined, id: string | undefined, fallback: string) => {
    if (name && id) {
        return `${name} (${id})`;
    }

    if (name) {
        return name;
    }

    if (id) {
        return `${fallback} (${id})`;
    }

    return fallback;
};

export const getTraderFilterValue = (trader: CascadeTrader) => {
    return trader.traderName?.value ?? trader.traderId;
};

export const getCascadeFilterValue = (name: string | undefined, id: string | undefined) => {
    return name ?? id;
};

export const getTraderKey = (trader: CascadeTrader) => {
    return [trader.traderId, trader.traderName?.value].filter(Boolean).join('-');
};

export const getGroupKey = (group: CascadeGroup) => {
    const key = [
        group.groupId,
        group.type,
        group.requested?.priority,
        group.requested?.traders?.map(getTraderKey).join('|'),
        group.skipped?.checkedTraders?.map(getTraderKey).join('|'),
        group.skipped?.reasons?.join('|'),
    ]
        .filter(Boolean)
        .join('-');

    return key || 'empty-group';
};

export const getAttemptKey = (attempt: PayoutCascadeAttempt) => {
    const key = [
        attempt.createdAt,
        attempt.attempt,
        attempt.type,
        attempt.cascadeMatched?.cascadeId,
        attempt.groups?.map(getGroupKey).join('|'),
    ]
        .filter(Boolean)
        .join('-');

    return key || 'empty-attempt';
};

export const getAttemptValue = (attempt: PayoutCascadeAttempt, index: number) => {
    if (typeof attempt.attempt === 'number') {
        return attempt.attempt;
    }

    return index + 1;
};

export const handleCascadePathLinkClick = () => {
    setMode('payout');
};
